import { render, staticRenderFns } from "./RoomControlPC.vue?vue&type=template&id=5c201f76&scoped=true&"
import script from "./RoomControlPC.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RoomControlPC.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RoomControlPC.vue?vue&type=style&index=0&id=5c201f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c201f76",
  null
  
)

export default component.exports